import { orchestrator } from 'satcheljs';
import { onSharedFolderFetchFailed } from 'owa-folders';
import { showErrorMessage } from 'owa-mail-folder-store';
import strings from 'owa-strings/owa-mail-strings';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';

/**
 * This orchestrator is responsible for showing the error dialog when getting subfolder call fails.
 * It also sets the folder to closed state if the action source of it is folderPane
 */
orchestrator(onSharedFolderFetchFailed, actionMessage => {
    showErrorMessage(strings.cantCompleteRequestText, strings.notEnoughPermissionText);
    if (actionMessage.actionSource === 'folderPane') {
        toggleFolderNodeExpansion(
            actionMessage.principalSMTPAddress,
            false /* doNotPersistUserConfig */
        );
    }
});
